export const statusOptions = [
    {
        id: 0,
        title: "Draft",
        value: "DRAFT",
    },
    {
        id: 1,
        title: "Published",
        value: "PUBLISHED",
    },
];
export const embedOptions = [
    {
        id: 0,
        title: "Allow Embedding",
        value: "true",
    },
    {
        id: 1,
        title: "Disallow Embedding",
        value: "false",
    },
];
export const categories = [
    { id: 0, title: "Beauty & Fashion", value: "BEAUTY_FASHION" },
    { id: 1, title: "Business", value: "BUSINESS" },
    { id: 2, title: "Cars & Trucks", value: "CARS_TRUCKS" },
    { id: 3, title: "Comedy", value: "COMEDY" },
    { id: 4, title: "Cute animals", value: "CUTE_ANIMALS" },
    { id: 5, title: "Entertainment", value: "ENTERTAINMENT" },
    { id: 6, title: "Family", value: "FAMILY" },
    { id: 7, title: "Food & Health", value: "FOOD_HEALTH" },
    { id: 8, title: "Home", value: "HOME" },
    { id: 9, title: "Lifestyle", value: "LIFESTYLE" },
    { id: 10, title: "Music", value: "MUSIC" },
    { id: 11, title: "News", value: "NEWS" },
    { id: 12, title: "Politics", value: "POLITICS" },
    { id: 13, title: "Science", value: "SCIENCE" },
    { id: 14, title: "Sports", value: "SPORTS" },
    { id: 15, title: "Technology", value: "TECHNOLOGY" },
    { id: 16, title: "Video games", value: "VIDEO_GAMING" },
    { id: 17, title: "Other", value: "OTHER" },
];
